module.exports = __webpack_public_path__ + "img/novo-card-compartilhavel.afe9eeda.jpeg";